// <copyright file="HelpPage.tsx">
// © 2023 Florida Department of Transportation
//
// The copyright to the computer program(s) and source code herein is
// the property of the Florida Department of Transportation.
// The program(s) and source code may be used and/or copied only with the
// written permission of the Florida Department of Transportation or
// in accordance with the terms and conditions stipulated in the
// agreement/contract under which the program(s) and source code have
// been supplied.
// </copyright>

import React, { useContext } from "react";
import styles from "src/components/HelpPage/HelpPage.module.css";
import ConfigContext from "src/context/ConfigContext";
import type { FC } from "react";
import type { IConfig } from "src/utils/ConfigLoader";

interface HelpPageProps {}

/*eslint-disable arrow-body-style*/
const HelpPage: FC<HelpPageProps> = () => {
    const configData = useContext(ConfigContext) as IConfig;
    if (!configData) {
        return null;
    }
    /*eslint-disable react/jsx-key*/
    return (
        <div className={styles.HelpPage} data-testid="HelpPage">
            <div className={styles.HelpPage_content}>
                <p>
                    To submit a request, report an issue, or access self-help
                    resources via a list of frequently asked questions, contact
                    us using the information below.
                    <br />
                </p>
                <h1>Contact Us</h1>
                {configData.footer?.contactUs.map((item) => (
                    <div dangerouslySetInnerHTML={{ __html: item }} />
                ))}
            </div>
        </div>
    );
};

export default HelpPage;
